import { LOCATIONS_LIST, LOCATIONS_PAGINATION,} from "./constant";
import { APICall } from "@/config/NetworkUtility";

export const getLocationList = (payload) => {
  return (dispatch) => {
    const queryParams = new URLSearchParams({
      ...payload,
    }).toString();

    const url = `v1/MaintainLocations/GetMaintainLocationsList?${queryParams}`;
    return APICall("get", payload, url).then(
      (result) => {
        if (result?.statuscode === 200 || result?.statuscode === 201) {
          dispatch({
            type: LOCATIONS_LIST,
            payload: result?.data || [],
          });
          dispatch({
            type: LOCATIONS_PAGINATION,
            payload: result?.pagination || {},
          });
          return result?.data;
        } else {
          return Promise.reject();
        }
      },
      (error) => {
        return Promise.reject(error);
      },
    );
  };
};

export const createLocation = (payload) => {
  const url = `v1/MaintainLocations/CreateLocations`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else if(result?.statuscode === 404 ){
        return result;
      } else {
        throw new Error((result?.statuscode));
      }
    },
    (error) => {
      return error;
    },
  );
};

export const UpdatecreateLocation = (payload) => {
  const url = `v1/MaintainLocations/UpdateLocations`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else if(result?.statuscode === 404 ){
        return result;
      } else {
        throw new Error((result?.statuscode));
      }
    },
    (error) => {
      return error;
    },
  );
};

export const DeleteLocation = (payload) => {
  const url = `v1/MaintainLocations/DeleteLocations`;
  return APICall("post", payload, url).then(
    async (result) => {
      if (result?.statuscode === 201 || result?.statuscode === 200) {
        return result;
      } else {
        return false;
      }
    },
    (error) => {
      return error;
    },
  );
};
